<app-si-dialog modalBodyClasses="overflow-hidden min-h-[200px] p-4" header="Export to {{ app?.app_name | titlecase }}">
	<ng-template appDialogBody>
		<div *ngIf="isBusy" class="mt-12">
			<div class="flex flex-wrap -mx-2">
				<div class="w-full sm:flex-none sm:w-5/6 text-center px-2">
					<b>{{busyLabel}}</b><br />
					{{busySublabel}}
				</div>
			</div>
		</div>

		<ng-container *ngIf="!isBusy" [ngSwitch]="currentPage?.name">
			<div class="pt-6" *ngSwitchCase="'loading'">
				<section>
					<div class="flex justify-center pt-6">
						<mat-spinner></mat-spinner>
					</div>
				</section>
			</div>

			<div class="contact-type" *ngSwitchCase="'contactType'">
				<h3>Contact Record Type {{ app?.is_contact_type_required ? '(Optional)' : '' }}</h3>
				Select the type of record you are exporting.
				<br /><br />
				<div class="table-scroll">
					<table class="si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="flex-none w-full px-2">
								Contact Record Type
							</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let contact_type of app?.contact_type_names">
							<td class="pt-2 pb-2" (click)="setContactType(contact_type)">
								Export as {{ contact_type | titlecase }}
							</td>
							<td class="check-column text-center py-0">
								<fa-icon [hidden]="contact_type !== contactType" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="contact-owner" *ngSwitchCase="'contactOwner'">
				<h3>Record Owner {{ app?.is_contact_owner_required ? '(Optional)' : '' }}</h3>
				Select an owner for the exported records.
				<br /><br />
				<div class="table-scroll">
					<table class="si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="flex-none w-full px-2">
								Record Owner
							</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let contact_owner of app?.contact_owner_names">
							<td class="pt-2 pb-2" (click)="setContactOwner(contact_owner)">
								{{ contact_owner | titlecase }}
							</td>
							<td class="check-column text-center py-0">
								<fa-icon [hidden]="contact_owner !== contactOwner" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="campaigns-workflow" *ngSwitchCase="'campaignsWorkflow'">
				<h3>Campaigns/Workflows {{ app?.is_campaign_workflow_required ? '(Optional)' : '' }}</h3>
				Select one or more campaigns to assign the exported records.
				<br /><br />
				<div class="table-scroll">
					<table class="si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="flex-none w-full px-2">
								Name
							</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let campaign_workflow of app?.campaign_workflow_names">
							<td class="pt-2 pb-2" (click)="setCampaignsWorkflow(campaign_workflow)">
								{{ campaign_workflow | titlecase }}
							</td>
							<td class="check-column text-center py-0">
								<fa-icon [hidden]="campaign_workflow !== campaignWorkflow" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="account-owner" *ngSwitchCase="'accountOwner'">
				<h3>Record Owner {{ app?.is_account_owner_required ? '(Optional)' : '' }}</h3>
				Select an owner for the exported records.
				<br /><br />
				<div class="table-scroll">
					<table class="si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="flex-none w-full px-2">
								Record Owner
							</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let account_owner of app?.account_owner_names">
							<td class="pt-2 pb-2" (click)="setAccountOwner(account_owner)">
								{{ account_owner | titlecase }}
							</td>
							<td class="check-column text-center py-0">
								<fa-icon [hidden]="account_owner !== accountOwner" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div *ngSwitchCase="'export'">
				<h3>Exporting</h3>
				<ng-container *ngIf="app?.request_type === requestType?.CONTACTS">
					Preparing to export {{ (itemsCount || contacts?.length) | number }} contact{{(itemsCount || contacts?.length) > 1 ? 's' : ''}} to {{ app?.app_name | titlecase }} app.
				</ng-container>
				<ng-container *ngIf="app?.request_type === requestType?.COMPANIES">
					Preparing to export {{ (itemsCount || companies?.length) | number }} {{ (itemsCount || companies?.length) > 1 ? 'companies' : 'company'}} to {{ app?.app_name | titlecase }} app.
				</ng-container>

			</div>

			<div *ngSwitchCase="'exportFinished'">
				<h3>Export Successful</h3>
				We have begun processing your export request.  This may take 30 minutes or more during busy times.
			</div>

			<div *ngSwitchCase="'exportFailed'">
				<h3>Export Failed</h3>
				Your export failed with the following error: <br /><br />
				<pre class="text-danger" style="max-height: 200px; white-space: pre-wrap;">{{exportError}}</pre><br />
			</div>
		</ng-container>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<button matButton="outlined" type="button" *ngIf="showCancelButton && !isBusy"
					(click)="onClose()">Cancel</button>
		</div>

		<div>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="showPreviousButton && !isBusy"
					(click)="previous()">Previous</button>
			<ng-container *ngIf="isExportButton && !isBusy">
				<button matButton="filled" type="button" class="ml-4" (click)="export()">
					Export</button>
			</ng-container>
			<button matButton="filled" type="button" *ngIf="showNextButton && !isBusy" (click)="next()">Next</button>
			<button matButton="filled" type="button" *ngIf="showRetryButton" (click)="retryExport()">Retry</button>
			<button matButton="outlined" type="button" *ngIf="showCloseButton" (click)="onClose()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
